export const CARD_FOCUS_CONTAINER_TEST_ID = 'platform-card.ui.card.focus-container';
